<div class="modal-inner">
    <h1 class="mb-2">Wijzigingshistorie urenregel #{{ data.realisation.id }}</h1>
    <h2>
        {{ data.realisation.hourtype | hourtype }}: {{ data.realisation.begindate | date: 'EEE d MMMM yyyy HH:mm' }} -
        {{ data.realisation.enddate | date: 'EEE HH:mm' }}
    </h2>

    <table class="table table-bordered table-striped table-hover">
        <thead>
            <tr>
                <th>Gewijzigd</th>
                <th>Door</th>
                @if (data.realisation.afas_project_id) {
                    <th>Project</th>
                }
                <th>Duur</th>
                <th>Pauze</th>
                <th>Starttijd</th>
                <th>Eindtijd</th>
                <th>Ingediend</th>
                <th>Goedgekeurd</th>
                @if (anyRemoved) {
                    <th>Verwijderd</th>
                }
                @if (anyCommentUser) {
                    <th>Toelichting gebr.</th>
                }
                @if (anyCommentManager) {
                    <th>Toelichting uitv.</th>
                }
                <th>Uitvoerder</th>
            </tr>
        </thead>
        <tbody>
            @for (history of histories; track history; let index = $index) {
                <tr>
                    <td>{{ history.updated_at | date: "HH:mm:ss, EEE d MMM ''yy" }}</td>
                    <td [class.downlight]="histories[index + 1]?.modified_by_user === history.modified_by_user">
                        {{ history.modified_by_user }}
                    </td>
                    @if (data.realisation.afas_project_id) {
                        <td [class.downlight]="histories[index + 1]?.afas_project_id === history.afas_project_id">
                            {{ history.afas_project_id }}
                        </td>
                    }
                    <td
                        class="text-right"
                        [class.downlight]="
                            Utils.minuteDuration(histories[index + 1]?.enddate, histories[index + 1]?.begindate) ===
                            Utils.minuteDuration(history.enddate, history.begindate)
                        ">
                        {{ Utils.minuteDuration(history.enddate, history.begindate) | minutes }}
                    </td>
                    <td [class.downlight]="histories[index + 1]?.pause === history.pause">
                        {{ history.pause | minutes }}
                    </td>
                    <td [class.downlight]="histories[index + 1]?.begindate === history.begindate">
                        {{ history.begindate | date: 'EEE HH:mm' }}
                    </td>
                    <td [class.downlight]="histories[index + 1]?.enddate === history.enddate">
                        {{ history.enddate | date: 'EEE HH:mm' }}
                    </td>
                    <td [class.downlight]="histories[index + 1]?.submitted === history.submitted">
                        {{ history.submitted | date: "EEE d MMM ''yy HH:mm" }}
                    </td>
                    <td [class.downlight]="histories[index + 1]?.approved === history.approved">
                        {{ history.approved | date: "EEE d MMM ''yy HH:mm" }}
                    </td>
                    @if (anyRemoved) {
                        <td [class.downlight]="histories[index + 1]?.removed === history.removed">
                            {{ history.removed | date: "EEE d MMM ''yy HH:mm" }}
                        </td>
                    }
                    @if (anyCommentUser) {
                        <td [class.downlight]="histories[index + 1]?.comment_user === history.comment_user">
                            {{ history.comment_user }}
                        </td>
                    }
                    @if (anyCommentManager) {
                        <td [class.downlight]="histories[index + 1]?.comment_manager === history.comment_manager">
                            {{ history.comment_manager }}
                        </td>
                    }
                    <td [class.downlight]="histories[index + 1]?.performer_id === history.performer_id">
                        {{ history.performer_name }}
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>
